import { NgModule, Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: 'vhpercent' })
export class vhpercentPipe implements PipeTransform {
  transform(value: string): any {
    if (value) {
      const percentageRegex = /^(\d+(\.\d+)?)%$/;
      if (percentageRegex.test(value)) {
        return value
      }
      else {
        // let a = value;
        let a = value.toString().replace(/\D/g, "")
        if (Number(a) > 100) a = '100';
        else if (Number(a) < 0) a = '1';
        return a + '%'
      }
    }
    return ''
  }
}

@Pipe({ name: 'vhnumber' })
export class vhnumberPipe implements PipeTransform {
  transform(value: string): any {
    if (value) {
      const regex = /-?\d+(\.\d+)?/g;
      const numbers = value.toString().match(regex);

      if (numbers) {
        const numberString = numbers.join("");
        return Number(numberString)
      } else {
        return ''
      }
    }
    return ''
  }
}
@NgModule({
  declarations: [vhpercentPipe,vhnumberPipe],
  
  imports: [
    
  ],
  exports: [vhpercentPipe,vhnumberPipe],
  
})
export class VhStringPercentPipeModule { }